import { MAP_TYPES } from '@deck.gl/carto';

const BROWARDTRANSITFACILITY_SOURCE_ID = 'browardTransitFacilitySource';

const source = {
  id: BROWARDTRANSITFACILITY_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'bmpo-smartmetro-09142026',
  data: 'SELECT * FROM `us-con-gcp-npr-0000424-011325.diamond.Broward_Transit_Facilities`',
};

export default source;
